import { Injectable, inject } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { LG_USER_INFO } from "@logex/framework/lg-application";
import { SharedAppUser } from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import { Observable } from "rxjs/internal/Observable";

@Injectable({
    providedIn: "root"
})
export class LegalConsentGuard  {
    private _router = inject(Router);
    private _userInfo = inject<SharedAppUser>(LG_USER_INFO);


    canActivate(): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
        return this._checkConsent();
    }

    canLoad(): Observable<boolean> | Promise<boolean> | boolean {
        return this._checkConsent();
    }

    private _checkConsent(): boolean {
        if (this._userInfo.SSPLegalConsentGranted) {
            return true;
        } else {
            this._router.navigate(["/legal-consent"]);
            return false;
        }
    }
}
